module.exports = __webpack_public_path__ + "img/blank-screen-lead-gen.cc816a8c.png";